export default __webpack_public_path__ + "static/media/corner.06bcb2fa.svg";